<template>
  <div class="sm-union">
    <!-- AlongShare-->
    <div class="share">
      <!-- 在 AlongShare 上以最低价格共享高级订阅服务-->
      <div class="sm-title-20 share-title" v-html="$t('home.lowerpricesharesmall')"></div>
      <!-- 连续 5 年提供高质量、价格合理的流媒体服务-->
      <div class="share-desc">{{$t('home.highqualitystreaming')}}</div>
      <div class="share-item" v-for="(item,i) in spuList" :key="i" @click="toBuy(item)">
        <div class="share-item-l">
          <img :src="item.homeimg" class="w-100">
        </div>
        <div class="share-item-r">
          <div class="share-item-title">{{item.goodsname}}</div>
          <div class="share-item-desc" v-if="!isEmpty(item.id)" v-html="$t('home.detail'+item.id)"></div>
          <div class="share-item-month">
            <!-- 月-->
            <span class="share-item-money">${{item.price}} </span>/ {{$t('subscribe.month')}}
          </div>
          <!-- How Use-->
          <div v-if="false" class="how" @click="howToUse">
            <img class="how-help" :src="`${$g.imgPrefix}/img/home/help.svg`">
            <div class="how-text">How Use</div>
          </div>
        </div>
      </div>

    </div>
    <!-- chat-->
    <div class="swiper white-bg chat" v-if="!isEmpty(chatList)">
      <van-swipe class="my-swipe" :autoplay="3000" :loop="true"  indicator-color="grey">
        <van-swipe-item class="message" v-for="(cItem,cIndex) in chatList" v-if="cItem.status!='0'" :key="cIndex">
          <div class="message-top">
            <img :src="cItem.img">
            <div class="message-user">{{ cItem.title }}</div>
          </div>
          <el-tooltip popper-class="phone-tooltip" effect="dark" :content="cItem.content" placement="bottom">
            <div class="message-desc">{{ cItem.content }}</div>
          </el-tooltip>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 分享你的订阅-->
    <div class="swiper">
      <van-swipe class="my-swipe" :loop="true" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <div class="swiper-top">
            <!-- 加入订阅-->
            <div class="swiper-top-title">{{$t('home.joinsubscription')}}</div>
            <img :src="`${$g.imgPrefix}/img/home/image135@2x.png`">
          </div>
          <ul class="swiper-content">
            <!-- 每月节省高达 80% 的订阅费。-->
            <li>{{$t('home.saveupsubscriptionfees')}}</li>
            <!-- 安全支付保障您的财务安全。-->
            <li>{{$t('home.securepayment')}}</li>
            <!-- 人工审核确保订阅的真实性和有效性。-->
            <li>{{$t('home.manualreview')}}</li>
            <!-- 一键加入！-->
            <li>{{$t('home.oneclickjoin')}}</li>
          </ul>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swiper-top">
            <!-- 分享你的订阅-->
            <div class="swiper-top-title">{{$t('home.shareyoursubscription')}}</div>
            <img :src="`${$g.imgPrefix}/img/home/image138@2x.webp`">
          </div>
          <ul class="swiper-content">
            <!-- 充分利用您订阅的可用时段。-->
            <li>{{$t('home.availabletime')}}</li>
            <!-- 赚钱并每月节省高达 80% 的订阅费。-->
            <li>{{$t('home.makemoney')}}</li>
            <!-- 广泛的订阅共享选项可让您赚取更多收入。-->
            <li>{{$t('home.widerangesubscription')}}</li>
            <!-- 只需三步分享！太简单！-->
            <li>{{$t('home.threestepsshare')}}</li>
          </ul>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- use-->
    <div class="use">
      <div class="use-item">
        <img :src="`${$g.imgPrefix}/img/home/Group1000005894@2x.webp`">
        <!-- SSL证书-->
        <div class="use-item-title">{{$t('home.certificate')}}</div>
      </div>
      <div class="use-item">
        <img :src="`${$g.imgPrefix}/img/home/Group1000005895@2x.webp`">
        <!-- 合适的订阅者-->
        <div class="use-item-title">{{$t('home.subscriber')}}</div>
      </div>
      <div class="use-item">
        <img :src="`${$g.imgPrefix}/img/home/Group1000005896@2x.webp`">
        <!-- 退款保证-->
        <div class="use-item-title">{{$t('home.moneyback')}}</div>
      </div>
      <div class="use-item">
        <img :src="`${$g.imgPrefix}/img/home/Group1000005881@2x.webp`">
        <!--  7×24 实时支持-->
        <div class="use-item-title">{{$t('home.onlinesupport')}}</div>
      </div>
    </div>

    <toBuy
        ref="toBuyRef"
        @goPay="goPay"
        :form1Obj="form1"
        :skuFilterList="skuFilterList"
    />
    <goPay
        ref="goPayRef"
        @closeToBuy="closeToBuy"
        @openBillDetails="openBillDetails"
        :form1Obj="form1"
        :goodsname="goodsname"
        :discountCodeFlag="discountCodeFlag"
    />

    <billingDetails
        ref="billingDetails"
        :form1Obj="form1"
    />

    <htmlModal ref="htmlModalRef">
      <div slot="htmlText" v-html="htmlText"></div>
    </htmlModal>
  </div>
</template>

<script>
import {
  getGoodsspuAll,
  getMessageList,
  paytypeall
} from "@/request/requests";
import {
  isEmpty,
  formatObj,
  MessageError
} from "@/util/util";
import toBuy from "./phome/toBuy";
import goPay from "./phome/goPay";
import billingDetails from "./phome/billingDetails";
import htmlModal from "./htmlModal";
export default {
  name: "union",
  components:{
    toBuy,
    goPay,
    billingDetails,
    htmlModal
  },
  data() {
    return {
      spuList: [],
      spu:'',
      goodsname:'',
      payOptions: [],
      skuFilterList:[],
      form1:{
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: "",
      },
      priceObj:{
        price:0,
        month:'',
        giftstimes:0,
      },
      chatList:[],
      discountCodeFlag:false,
      htmlText:'<h2>ddddd</h2>'
    }
  },
  methods: {
    isEmpty,
    async getMessageList(){
      let params = {
        page: 1,
        size: 10
      }
      this.chatList = [];
      let res = await getMessageList(this.$qs.stringify(params));
      if (res.status == "200") {
        this.chatList = res.data.list;
        if(!isEmpty(this.chatList)){
          this.chatList.forEach(item=>{
            this.$set(item,'img',`${this.$g.imgPrefix}/img/home/avatar.svg`);
          })
        }
      } else {
        MessageError(res.msg);
      }
    },
    howToUse(){
      this.$refs['htmlModalRef'].init();
    },
    openBillDetails(){
      this.$refs['billingDetails'].init();
    },
    closeToBuy(){
      this.$nextTick(()=>{
        this.$refs['toBuyRef'].closeDialog();
      })
    },
    toBuy(spu){
      if(spu.goodsname=='share ai'){
        if(spu.isbuy == '1'){
          this.$router.push({
            name:'shareAI'
          })
          return;
        }
      }else{
        if(spu.isbuy == '1'){
          this.spu = spu;
          this.goodsname = this.spu.goodsname;
          this.form1 = {
            goodsid: spu.id,
            num: 1,
            buytype: "1",
            paycode: "",
            //this.payOptions[0].value,
            discountcode: "",
            skuid: spu.skus[0].id
          }
          this.$nextTick(()=>{
            this.$refs['toBuyRef'].init(formatObj(this.spu));
          })
        }
      }
    },
    /**
     * @param priceObj 价格对象
     * @param form1
     * @param discountCodeFlag 折扣码是否已经生效 true/false
     */
    goPay(priceObj,form1,discountCodeFlag){
      this.discountCodeFlag = discountCodeFlag;
      this.form1 = form1;
      this.$nextTick(()=>{
        this.$refs['goPayRef'].init(priceObj);
      })
    },
    async paytypeallInfo() {
      let res = await paytypeall();
      if (res.status == "200") {
        this.payOptions = res.data;
      } else {
        MessageError(res.msg);
      }
    },
    async getGoodsspuAllInfo() {
      //let loading = startLoading();
      let res = await getGoodsspuAll();
      if (res.status == "200") {
        this.spuList = res.data;
        // 找到 id 为 x 的项目
        let itemToMove = this.spuList.find(item => item.id === 11);
        if (itemToMove) {
          // 从原列表中移除该项目
          this.spuList = this.spuList.filter(item => item.id !== 11);
          // 如果登录 将该项目插入到列表的第二个位置（索引 1 处）
          let token = this.$cookies.get('token');
          if (token) {
            this.spuList.splice(1, 0, itemToMove);
          }
        }
        //loading.close();
      } else {
        MessageError(res.msg);
        // loading.close();
      }
      // loading.close();
    },

  },
  mounted(){
    this.getGoodsspuAllInfo();
    this.paytypeallInfo();
    this.getMessageList();
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/union.scss";
</style>
<style lang="scss">
.swiper{
  background: #F0FFF0;
  border-radius: 32px;
  padding:16px 20px 12px 24px;
  margin-bottom:40px;

  &-top{
    display:flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom:17px;
    &-title{
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 20px;
      color: #040404;
      line-height: 23px;
      word-break: break-word;
      text-align: left;
      width:calc(100% - 60px);
    }
    img{
      width:60px;
      object-fit: cover;
    }

  }
  &-content{
    padding-bottom:46px;
    li{
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 14px;
      color: #040404;
      line-height: 16px;
      text-align: left;

      &:not(:last-child){
        margin-bottom:12px;
      }

    }
  }

  .my-swipe{
    .van-swipe-item {
      font-size: 20px;
      line-height: 150px;
      text-align: center;
    }
    .van-swipe__indicator{
      width: 8px;
      height: 8px;
      background: #fff!important;
      &--active{
        width: 8px;
        height: 8px;
        background: #5BC17F!important;
      }
    }


  }
}
.phone-tooltip.el-tooltip__popper {
  width: 80%;
}
</style>